<template>
  <div>
    <a-card class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="任务名称">
              <a-input v-model="filterForm.name" placeholder="任务名称" class="form-model-item" @change="handleChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="状态">
              <a-select v-model="filterForm.status" @change="handleChange">
                <a-select-option :value="1"> <a-badge status="processing" text="Running" /> </a-select-option>
                <a-select-option :value="0"> <a-badge status="warning" text="Stopped" /> </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-button type="primary" @click="getSchedulerList">查询</a-button>
            <a-button :style="{ margin: '0 8px' }" @click="onReset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="定时任务列表" class="filter-data">
      <span slot="extra">
        <a-button v-has="{ code: 'system:scheduler:add', project: 0 }" class="handle-menu" type="primary" icon="plus" @click="onAdd">添加</a-button>
      </span>
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="id" :loading="loading" @change="handlePageChange">
        <span slot="crontab" slot-scope="text, record">{{ record.crontab ? record.crontab : `${record.interval_every}${record.interval_period}` }} </span>
        <span slot="action" slot-scope="text, record">
          <a v-dis="{ code: 'system:scheduler:run', project: 0 }" @click="onSchedulerRun(record)">执行</a>
          <a-divider type="vertical" />
          <a v-dis="{ code: 'system:scheduler:status:switch', project: 0 }" @click="onModifyStatus(record)">{{ record.status === true ? '停止' : '启动' }}</a>
          <a-divider type="vertical" />
          <a v-dis="{ code: 'system:scheduler:edit', project: 0 }" @click="onEdit(record)">编辑</a>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-badge :status="record.status == 1 ? 'processing' : 'warning'" :text="record.status == 1 ? 'Running' : 'Stopped'" />
        </span>
      </a-table>
    </a-card>
    <scheduler-modal :is-show="modalVisible" :scheduler-id="schedulerId" :scheduler-form="schedulerForm" @close="close" />
    <scheduler-run-modal :is-show="runModalVisible" :scheduler-form="runModalForm" @close="close" />
  </div>
</template>

<script>
import SchedulerModal from '@/pages/system/components/SchedulerModal';
import SchedulerRunModal from '@/pages/system/components/SchedulerRunModal';
import { schedulerList, schedulerModifyStatus } from '@/api/system/scheduler';
const columns = [
  {
    title: '任务ID',
    dataIndex: 'id',
    key: 'id',
    align: 'center',
    width: 80
  },
  {
    title: '任务名称',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '执行器',
    dataIndex: 'handler',
    key: 'handler'
  },
  {
    title: '执行策略',
    key: 'crontab',
    dataIndex: 'crontab',
    scopedSlots: { customRender: 'crontab' }
  },
  {
    title: '执行参数',
    key: 'kwargs',
    ellipsis: true,
    width: 200,
    dataIndex: 'kwargs'
  },
  {
    title: '备注',
    ellipsis: true,
    key: 'description',
    dataIndex: 'description'
  },
  {
    title: '状态',
    key: 'status',
    dataIndex: 'status',
    align: 'center',
    width: 100,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    align: 'center',
    width: 160,
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  components: {
    SchedulerModal,
    SchedulerRunModal
  },
  data() {
    return {
      filterForm: {
        name: null,
        status: null,
        page_size: 10,
        page_number: 1
      },
      loading: false,
      runModalForm: {},
      runModalVisible: false,
      modalVisible: false,
      schedulerId: null,
      schedulerForm: {},
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      expand: false,
      tableData: [],
      columns
    };
  },
  computed: {
    count() {
      return this.expand ? 11 : 7;
    }
  },
  mounted() {
    this.getSchedulerList();
  },
  methods: {
    handleChange() {
      this.filterForm.page_number = 1;
      this.getSchedulerList();
    },

    // 点击添加
    onAdd() {
      this.schedulerId = null;
      this.schedulerForm = {};
      this.modalVisible = true;
    },

    // 点击编辑
    onEdit(record) {
      this.schedulerId = record.id;
      this.schedulerForm = record;
      this.modalVisible = true;
    },

    // 点击重置
    onReset() {
      this.filterForm = {
        name: null,
        status: null,
        page_size: 10,
        page_number: 1
      };
      this.getSchedulerList();
    },

    toggle() {
      this.expand = !this.expand;
    },

    // 获取定时任务列表
    async getSchedulerList() {
      this.loading = true;
      const { code, message, data } = await schedulerList(this.filterForm);
      if (code === 2000) {
        this.tableData = data.scheduler_list;
        this.pagination.total = data.total;
        this.loading = false;
      } else {
        this.loading = false;
        this.$message.warning(message);
      }
    },

    // 执行定时任务
    onSchedulerRun(record) {
      this.runModalForm = {
        id: record.id,
        name: record.name,
        handler: record.handler,
        params: record.kwargs
      };
      this.runModalVisible = true;
    },

    // 修改定时任务状态
    onModifyStatus(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: `确认${record.status === true ? '停止' : '启动'}该定时任务吗`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          const { code, message } = await schedulerModifyStatus({ scheduler_id: record.id, status: !record.status });
          if (code === 2000) {
            self.$message.success(`定时任务${record.status === true ? '停止' : '启动'}成功`);
            self.getSchedulerList();
          } else {
            self.$message.warning(message);
          }
        }
      });
    },

    handlePageChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.getSchedulerList();
    },

    // 关闭弹窗
    close() {
      this.modalVisible = false;
      this.runModalVisible = false;
      this.runModalForm = {};
      this.getSchedulerList();
    }
  }
};
</script>

<style lang="less">
.customer-filter {
  margin-bottom: 16px;
}

.handle-menu {
  margin: 0 5px;
}
.search-form .ant-form-item {
  display: flex;
}

.search-form .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0;
}
</style>
